export default __webpack_public_path__ + "static/REFACTR.TECH_2022-efc17d5e508f39b7fbf01b24fc599e25.png";